import React, { useMemo, useState, useEffect } from 'react'
import _ from 'lodash';
import { getSumOfGroupByMultiFields, groupingByMultipleFields } from '../../utils/group-helpers';
import "./customTable.css";

export default function AdvancedGroupingTable(props) {
    const { columns, dataSource, summaryData, tableID, groupConfig } = props

    const [columsSet, setColumsSet] = useState([])
    const [reportData, setReportData] = useState([])

    // Advanced grouping needs a Column and a Value to pivot on. Without them the
    // config is incomplete - it used to read [0].fieldName and throw.
    const columnField = groupConfig?.selectedColumns?.[0]?.fieldName
    const valueField = groupConfig?.selectedValues?.[0]?.fieldName
    const isConfigComplete = Boolean(columnField && valueField && groupConfig?.selectedRows?.length)

    const valueConfig = groupConfig?.selectedValues?.[0]?.config || {}
    const aggFunction = valueConfig.func || "sum"
    const showAs = valueConfig.showas || "value"
    const showColumnTotals = Boolean(groupConfig?.selectedColumns?.[0]?.config?.showTotals)

    useEffect(() => {
        if (!isConfigComplete || dataSource.length === 0) {
            setColumsSet([])
            setReportData([])
            return
        }

        let uniqueCols = _.uniq(dataSource.map(x => x[columnField])).map((col, i) => {
            return {
                checked: true,
                key: `gp_c_key_${i}`,
                dataIndex: col,
                title: col,
                isGroupCol: true,
                dataType: 'number'
            }
        })
        const uniqueColKeys = uniqueCols.map(uc => uc.dataIndex)

        let gTotalCol = []
        if (showColumnTotals) {
            gTotalCol = [{
                checked: true,
                key: `gp_GT_c_key`,
                dataIndex: 'GrandTotal',
                title: 'Grand Total',
                isGroupCol: true,
                dataType: 'number'
            }]
        }
        setColumsSet([
            ...columns.filter(x => groupConfig.selectedRows.findIndex(y => y.fieldName === x.dataIndex) > -1),
            ...uniqueCols,
            ...gTotalCol
        ])

        // spread each row's value into its own column, then aggregate by the row keys.
        // Count is "sum of 1s" and Average is "sum / count", so all three reuse the
        // same summing helper rather than needing separate aggregation paths.
        const buildPivot = (mapValue) => {
            const spread = dataSource.map(dc => {
                let obj = {}
                uniqueCols.forEach(uc => {
                    obj[uc.dataIndex] = dc[columnField] === uc.dataIndex ? mapValue(dc) : 0
                })
                return { ...dc, ...obj }
            })
            return getGroupedData(spread, uniqueColKeys)
        }

        let result
        if (aggFunction === "count") {
            result = buildPivot(() => 1)
        } else if (aggFunction === "average") {
            const sums = buildPivot(dc => Number(dc[valueField]) || 0)
            const counts = buildPivot(() => 1)
            result = sums.map((row, i) => {
                const out = { ...row }
                uniqueColKeys.forEach(k => {
                    const c = counts[i]?.[k]
                    out[k] = c ? row[k] / c : 0
                })
                return out
            })
        } else {
            result = buildPivot(dc => Number(dc[valueField]) || 0)
        }

        result = applyShowAs(result, uniqueColKeys)

        if (showColumnTotals) {
            result = result.map(row => ({
                ...row,
                GrandTotal: uniqueColKeys.reduce((a, k) => a + (Number(row[k]) || 0), 0),
            }))
        }

        setReportData(result)
    }, [columns, groupConfig, dataSource])

    // "Show As" turns the aggregated numbers into percentages of the row, the column
    // or the whole table. "value" leaves them as they are.
    const applyShowAs = (rows, valueKeys) => {
        if (showAs === "value" || !rows.length) return rows

        const columnTotals = {}
        valueKeys.forEach(k => {
            columnTotals[k] = rows.reduce((a, r) => a + (Number(r[k]) || 0), 0)
        })
        const grandTotal = Object.values(columnTotals).reduce((a, b) => a + b, 0)

        const percent = (part, whole) => (whole ? (Number(part) || 0) / whole * 100 : 0)

        return rows.map(row => {
            const rowTotal = valueKeys.reduce((a, k) => a + (Number(row[k]) || 0), 0)
            const out = { ...row }
            valueKeys.forEach(k => {
                if (showAs === "percentage_row") out[k] = percent(row[k], rowTotal)
                else if (showAs === "percentage_col") out[k] = percent(row[k], columnTotals[k])
                else if (showAs === "percentage_total") out[k] = percent(row[k], grandTotal)
            })
            return out
        })
    }

    const getGroupedData = (rd, sumKeysArg) => {
        let groupByKeys = groupConfig.fieldNamesList ? groupConfig.fieldNamesList : [];
        let sumKeys = sumKeysArg || _.uniq(dataSource.map(x => x[columnField]));
        let result = getSumOfGroupByMultiFields(rd, groupByKeys, sumKeys);

        let count = groupingByMultipleFields(rd, function (item) {
            return groupByKeys?.map((key) => item[key]);
        });
        // result = result?.map((obj) =>
        //     Object.fromEntries(
        //         Object.entries(obj)?.filter(
        //             (o) =>
        //                 [...groupByKeys, ...sumKeys]?.includes(o[0]) //||
        //                 // groupConfig?.uniqueFieldNamesList?.includes(o[0])
        //         )
        //     )
        // );
        // let columns = Object.keys(result[0]).map((val, i) => ({
        //     id: i,
        //     fieldName: val,
        //     checked:
        //       resource.availableFields?.find(
        //         (af) => af.fieldName === val
        //       )?.checked ?? true,
        //     dataType: resource.allFields?.find(
        //       (af) => af.fieldName === val
        //     )?.dataType,
        //     grouped: true,
        //   }));



        if (groupConfig?.operator === 'sum&count' || groupConfig?.operator === 'count') {
            count = count?.map((c) => c?.length);

            // columns.push({
            //   id: v4(),
            //   fieldName: "Count",
            //   checked:
            //   resource.availableFields?.find(
            //       (af) => af.fieldName === "Count"
            //     )?.checked ?? true,
            //   dataType: "number",
            //   grouped: true,
            // });

            result = result.map((res, i) => Object.assign(res, { 'Count': count[i] }));
            return result
        } else {
            return result
        }


        //     return {
        //       data: result?.length ? result : [],
        //       fields: columns?.length ? columns : [],
        //     };
        //   } else {
        //     return {
        //       data: result?.length ? result : [],
        //       fields: columns?.length ? columns : [],
        //     };
        //   }

    };

    const memorizedRows = useMemo(() => {
        if (columsSet) {
            if (dataSource.length > 0) {
                return reportData.map((ds, i) => {
                    return (
                        <tr key={`tr_${i}`} style={{ borderBottom: '1px solid #eee' }}>

                            {(summaryData && summaryData.length > 0) || (groupConfig && groupConfig.advanced && groupConfig.selectedColumns?.length > 0) ?
                                <td className="summary-data-space">&nbsp;</td>
                                : null}
                            {columsSet.map((dsc, j) => {
                                return (
                                    <td key={`td_${i}_${j}`}>{dsc.render ? dsc.render(ds[dsc.dataIndex]) : ds[dsc.dataIndex] ? dsc.dataType === 'number' ? Number(ds[dsc.dataIndex]).toFixed(2) : ds[dsc.dataIndex] : ''}</td>
                                )
                            })}
                        </tr>
                    )
                })
            } else {
                return (
                    <tr>
                        <td colspan="100%" >
                            <div style={{ width: '100%', textAlign: 'center', padding: '24px' }}>
                                Data Not Available
                            </div>
                        </td>
                    </tr>
                )
            }
        }
    }, [reportData, columsSet, summaryData]);

    const getMemorizedTotal = (fieldName) => {
        return reportData.reduce((a, b) => { return a + Number(b[fieldName]) }, 0).toFixed(2)
    }

    const matched = (dataArr, a) => {
        return dataArr?.filter((b) => a === b?.fieldName);
    };

    const onCalculationValue = (aggrigationtype, field) => {
        if (aggrigationtype === "sum") {
            return reportData
                ?.reduce((a, curr) => Number(a) + Number(curr[field]), 0)
                ?.toFixed(2);
        } else if (aggrigationtype === "average") {
            return (
                reportData?.reduce(
                    (a, curr) => Number(a) + Number(curr[field]),
                    0
                ) / reportData?.length
            )?.toFixed(2);
        } else if (aggrigationtype === "minimum") {
            return Math.min(
                ...reportData?.map((o) => Number(o[field]))
            );
        } else if (aggrigationtype === "maximum") {
            return Math.max(
                ...reportData?.map((o) => Number(o[field]))
            );
        } else if (aggrigationtype === "count") {
            return reportData?.length;
        } 
        // else if (aggrigationtype === "standarddeviation") {
        //     return dev(reportData?.map((o) => Number(o[field])));
        // } else if (aggrigationtype === "variance") {
        //     return ver(reportData?.map((o) => Number(o[field])));
        // } else if (aggrigationtype === "median") {
        //     return median(reportData?.map((o) => Number(o[field])));
        // }
        return null;
    };


    if (!isConfigComplete) {
        return (
            <div className="widget-table-container">
                <div style={{ width: '100%', textAlign: 'center', padding: '24px', color: '#94a3b8' }}>
                    Advanced grouping needs a Row, a Column and a Value. Complete the Grouping
                    configuration and press Apply.
                </div>
            </div>
        )
    }

    return (
        <div className="widget-table-container">
            {columns ?
                <table className="widget-table" id={`widgetTable${tableID}`}>
                    <thead>
                        <tr>
                            {(summaryData && summaryData.length > 0) || (groupConfig && groupConfig.advanced && groupConfig.selectedColumns?.length > 0) ?
                                <th className='summary-data-space custom-table-th'>&nbsp;</th>
                                : null}
                            {columsSet.map((c, k) => {
                                return (
                                    <th key={`th_${k}`} className="custom-table-th">{c.title}</th>
                                )
                            })}
                        </tr>
                    </thead>
                    <tbody style={{ borderBottom: '1px solid #aaa', borderTop: '1px solid #aaa' }}>
                        {memorizedRows}
                    </tbody>
                    <tfoot>
                        {summaryData && summaryData.length > 0 ?
                            <>
                                {summaryData.map((field, index) => (
                                    <tr>
                                        {field ? <td className='summary-data-space'> <b>{field?.displayName ?? ""}</b></td> : <td></td>}

                                        {dataSource.length > 0 && Object.keys(dataSource[0]) &&
                                            columns
                                                ?.map((a, id) => {
                                                    return field ? (
                                                        matched([{ ...field }], a.dataIndex).length ? (
                                                            <td index={id}>
                                                                <b>
                                                                    {onCalculationValue(
                                                                        matched([{ ...field }], a.dataIndex)[0]
                                                                            .aggType,
                                                                        matched([{ ...field }], a.dataIndex)[0]
                                                                            .fieldName
                                                                    )}
                                                                </b>
                                                            </td>
                                                        ) : (
                                                            <td
                                                                index={id}
                                                            ></td>
                                                        )
                                                    ) : null;
                                                })}
                                    </tr>
                                ))}
                            </> : null}

                        <tr className='build-talals-row'>
                            {
                                groupConfig && groupConfig.advanced && groupConfig.selectedRows?.[0]?.config?.showTotals && columnField ?
                                    <>
                                        <td className='build-talals-item'>Grand Total</td>

                                        {reportData.length > 0 && Object.keys(reportData[0]) &&
                                            columsSet
                                                ?.map((a, id) => (
                                                    <td className='build-talals-item' index={id}>
                                                        {_.uniq(dataSource.map(x => x[columnField])).findIndex(x => x === a.dataIndex) > -1 ? getMemorizedTotal(a.dataIndex) : a.dataIndex==="GrandTotal"? getMemorizedTotal('GrandTotal'):''}
                                                    </td>
                                                ))}

                                    </>

                                    : null
                            }
                        </tr>

                    </tfoot>


                </table>
                : null}
        </div>
    )

}
